const changeMigrationEntityStatus = {
  data: {}
}

export default changeMigrationEntityStatus;
